import React, { Component, createRef } from 'react'
import { connect } from "react-redux";
import { Col, Container, Image } from 'react-bootstrap';
import styles from '../../ecom/ecom.scss';
import Piechart from '../../../shared/components/charts/Piechart';
import Linegraph_sparkline from '../../../shared/components/charts/Linegraph_sparkline';
import { ChartCard } from '../../../shared/components/cards/chartcard/chartcard'
import { Carousel } from '../../../shared/components/carousel/carousel';
import '../../../shared/components/cards/card.scss';
import IconWebsite from '../../../../assets/images/icons/websiteIcon';
import Wrapper from '../../../helpers/wrapper';
import { DailydataDropdown } from '../../../shared/components/dropdown/dailydatadropdown';
import Sunbrust_chart from '../../../shared/components/charts/Sunbrust_chart';
import { LocationBarChart } from '../../../shared/components/charts/LocationBarChart';
import CompareLineChart from "../../../shared/components/charts/CompareLineChart";
import DatedbasedBubbleChart from '../../../shared/components/charts/DatedbasedBubbleChart';
import Treemap from '../../../shared/components/charts/TreeMap';
import ColumnLineChart from '../../../shared/components/charts/ColumnLineChart';
import ColumnLineChart_1 from '../../../shared/components/charts/ColumnLineChart_1';
import DataTable from '../../../shared/components/Datatable/DataTable';
import BubbleTimelineChart from '../../../shared/components/charts/BubbleTimelineChart';
import BubbleTextchart from '../../../shared/components/charts/BubbleTextchart';
// import { API_URL_1 } from "../../../helpers/constant";
import { API_URL_1 } from '../../../helpers/constant';
import { ThemeConsumer } from 'react-bootstrap/esm/ThemeProvider';
import DatePicker from '../../../shared/components/datepicker/datepicker';
import IconPdf from '../../../../assets/images/icons/pdfIcon';
import ChartExport from '../../../shared/components/export/ChartExport';
import StickyLogo from '../../../../assets/images/icons/icon.png'
import { Loader } from '../../../shared/components/loader/loader';
import MultiLine_LineChart from '../../../shared/components/charts/multiLineChart';
import RiTreegraph1 from "../../../shared/components/charts/RiTreegraph1";
import FourLine_LineChart from '../../../shared/components/charts/FourLine_LineChart';
import '../../../layout/pageheader/pageheader.scss'
import PageHeader from '../../../../../components/layout/pageHeader';
import { CountryCode } from '../../../../../constants/countryCurrency';


export class Earned extends Component {
    scrollDiv = createRef();
    scrollSearch = createRef();

    getCountryCurrency = () => {

        let userCountryCode = localStorage.getItem('static-country-code');
        var currValue = ''

        CountryCode.map((data) => {
            if (data.countryCode === userCountryCode) {
                //   country = data;
                currValue = data.currencySymbol
            }
        });

        return currValue;
    }
    constructor(props) {
        super(props);
        this.state = {
            trafficeChannel: '',
            // treegraph1: [{ "name": "Campaign", "children": [{ "name": "Diwali", "value": 150 }, { "name": "BOGO", "value": 350 }] }, { "name": "Product", "children": [{ "name": "Watch", "value": 350 }, { "name": "Mobile", "value": 400 }] }, { "name": "Category", "children": [{ "name": "Electronics", "children": [{ "name": "Accessories", "value": 240 }] }, { "name": "Apparel", "value": 100 }] }, { "name": "Sign Up", "value": 180 }],
            // treegraph1: [
            //     {
            //       "name": "Campaign",
            //       "value": 100
            //     },
            //     {
            //       "name": "Product",
            //       "value": 200
            //     },
            //     {
            //       "name": "Category",
            //        "value": 330
            //     },
            //     {
            //       "name": "Sign Up",
            //       "value": 180
            //     }
            //   ],

            treegraph1: [{ "name": "APPARELS", "nsv": 210496864, "value": 804, "asp": 804.13, "units_sold": 261769, "store_nsv": 1119151444, "total_nsv": 1119151444, "nsv_mix": 85.85, "color": "#038673" }, { "name": "NSM & OTHERS", "nsv": 483022, "value": 3, "asp": 3.05, "units_sold": 158555, "store_nsv": 1119151444, "total_nsv": 1119151444, "nsv_mix": 0.2, "color": "#d51f30" }, { "name": "LIFESTYLE", "nsv": 34222282, "value": 840, "asp": 840.49, "units_sold": 40717, "store_nsv": 1119151444, "total_nsv": 1119151444, "nsv_mix": 13.96, "color": "#038673" }],
            user: [{ "date": "2019-5-12", "value1": "50", "value2": "48", "previousdate": "2019-5-5" }, { "date": "2019-5-13", "value1": "53", "value2": "51", "previousdate": "2019-5-6" }, { "date": "2019-5-14", "value1": "56", "value2": "58", "previousdate": "2019-5-7" }, { "date": "2019-5-15", "value1": "52", "value2": "53", "previousdate": "2019-5-8" }, { "date": "2019-5-16", "value1": "48", "value2": "44", "previousdate": "2019-5-9" }, { "date": "2019-5-17", "value1": "47", "value2": "42", "previousdate": "2019-5-10" }, { "date": "2019-5-18", "value1": "59", "value2": "55", "previousdate": "2019-5-11" }],
            locationdata: [{ "name": "Top-10", "points": 100 }, { "name": "10-20", "points": 200 }, { "name": "20-30", "points": 110 }, { "name": "30-40", "points": 100 }, { "name": "40-50", "points": 100 }, { "name": "50-100", "points": 100 }],
            datatabledropdown_options: [{ "value": "Landing Page", "label": "Landing Page" }, { "value": "Channel/Source/Medium", "label": "Channel/Source/Medium" }, { "value": "Device Type", "label": "Device Type" }, { "value": "Browser", "label": "Browser" }, { "value": "User type", "label": "User type" }],
            trafficdropdown_options: [{ "value": "select source", "label": "Select Source" }, { "value": "Website", "label": "Website" }],
            chartData: [{ "country": "Lithuania", "litres": 500, "subData": [{ "name": "A", "value": 200 }, { "name": "B", "value": 150 }, { "name": "C", "value": 100 }, { "name": "D", "value": 50 }] }, { "country": "Czech Republic", "litres": 300, "subData": [{ "name": "A", "value": 150 }, { "name": "B", "value": 100 }, { "name": "C", "value": 50 }] }, { "country": "Ireland", "litres": 200, "subData": [{ "name": "A", "value": 110 }, { "name": "B", "value": 60 }, { "name": "C", "value": 30 }] }, { "country": "Germany", "litres": 150, "subData": [{ "name": "A", "value": 80 }, { "name": "B", "value": 40 }, { "name": "C", "value": 30 }] }, { "country": "Australia", "litres": 140, "subData": [{ "name": "A", "value": 90 }, { "name": "B", "value": 40 }, { "name": "C", "value": 10 }] }, { "country": "Austria", "litres": 120, "subData": [{ "name": "A", "value": 60 }, { "name": "B", "value": 30 }, { "name": "C", "value": 30 }] }],
            dropdown_options: [{ "value": "impressions", "label": "Impressions" }, { "value": "clicks", "label": "Clicks" }],
            search_type: "impressions",

            mention_word_dropdown_option: [{ "value": "", "label": "All Events" }, { "value": "Add_to_cart", "label": "Add To Cart" }, { "value": "Add_to_Wishlist", "label": "Add to Wishlist" }, { "value": "LostFestive banner", "label": "LostFestive banner" }],
            multiline_chart_data: [],
            // multiline_chart_data: [{ facebook: 3035, google: 2680 , year: "2021-03-01" }, { facebook: 1035, google: 2680, instagram: 2158, linkedin: 2216, twitter: 2078, year: "2021-03-02" }, { facebook: 1035, google: 1680, instagram: 1158, linkedin: 1216, twitter: 1078, year: "2021-03-03" }, { facebook: 8035, google: 8680, instagram: 5158, linkedin: 5216, twitter: 7078, year: "2021-03-04" }],

            trafficpievalue: [{ "name": "Social", "value": 30 }, { "name": "Direct", "value": 30 }, { "name": "Website", "value": 50 }, { "name": "Email", "value": 40 }, { "name": "Organic", "value": 60 }],
            linesparkgraph: [{ "date": "2012-07-27", "value": 13 }, { "date": "2012-07-28", "value": 10 }, { "date": "2012-07-29", "value": 15 }, { "date": "2012-07-30", "value": 15 }, { "date": "2012-07-31", "value": 15 }, { "date": "2012-08-01", "value": 15 }, { "date": "2012-08-02", "value": 15 }, { "date": "2012-08-03", "value": 19 }, { "date": "2012-08-04", "value": 16 }, { "date": "2012-08-05", "value": 15 }, { "date": "2012-08-06", "value": 19 }, { "date": "2012-08-07", "value": 17 }, { "date": "2012-08-08", "value": 18 }],
            bubblechart: [{ "date": "2015-01-01", "weekday": "Sun", "value": 2990 }, { "hour": "1pm", "weekday": "Sun", "value": 2990 }, { "hour": "2pm", "weekday": "Sun", "value": 1990 }, { "hour": "3pm", "weekday": "Sun", "value": 990 }, { "hour": "4pm", "weekday": "Sun", "value": 2000 }, { "hour": "5pm", "weekday": "Sun", "value": 7890 }, { "hour": "6pm", "weekday": "Sun", "value": 1290 }, { "hour": "7pm", "weekday": "Sun", "value": 1090 }, { "hour": "8pm", "weekday": "Sun", "value": 2990 }, { "hour": "9pm", "weekday": "Sun", "value": 2990 }, { "hour": "10pm", "weekday": "Sun", "value": 2990 }, { "hour": "11pm", "weekday": "Sun", "value": 2990 }, { "hour": "12pm", "weekday": "Sun", "value": 2990 }, { "hour": "1am", "weekday": "Sun", "value": 1890 }, { "hour": "2am", "weekday": "Sun", "value": 1990 }, { "hour": "3am", "weekday": "Sun", "value": 1000 }, { "hour": "4am", "weekday": "Sun", "value": 2100 }, { "hour": "5am", "weekday": "Sun", "value": 2990 }, { "hour": "6am", "weekday": "Sun", "value": 2100 }, { "hour": "7am", "weekday": "Sun", "value": 2990 }, { "hour": "8am", "weekday": "Sun", "value": 1200 }, { "hour": "9am", "weekday": "Sun", "value": 900 }, { "hour": "10am", "weekday": "Sun", "value": 2000 }, { "hour": "11am", "weekday": "Sun", "value": 1100 }, { "hour": "12am", "weekday": "Sun", "value": 2990 }, { "hour": "12pm", "weekday": "Mon", "value": 2990 }, { "hour": "1pm", "weekday": "Mon", "value": 2990 }, { "hour": "2pm", "weekday": "Mon", "value": 1990 }, { "hour": "3pm", "weekday": "Mon", "value": 990 }, { "hour": "4pm", "weekday": "Mon", "value": 2000 }, { "hour": "5pm", "weekday": "Mon", "value": 7890 }, { "hour": "6pm", "weekday": "Mon", "value": 1290 }, { "hour": "7pm", "weekday": "Mon", "value": 1090 }, { "hour": "8pm", "weekday": "Mon", "value": 2990 }, { "hour": "9pm", "weekday": "Mon", "value": 2990 }, { "hour": "10pm", "weekday": "Mon", "value": 2990 }, { "hour": "11pm", "weekday": "Mon", "value": 2990 }, { "hour": "12pm", "weekday": "Mon", "value": 2990 }, { "hour": "1am", "weekday": "Mon", "value": 1890 }, { "hour": "2am", "weekday": "Mon", "value": 1990 }, { "hour": "3am", "weekday": "Mon", "value": 1000 }, { "hour": "4am", "weekday": "Mon", "value": 2100 }, { "hour": "5am", "weekday": "Mon", "value": 2990 }, { "hour": "6am", "weekday": "Mon", "value": 2100 }, { "hour": "7am", "weekday": "Mon", "value": 2990 }, { "hour": "8am", "weekday": "Mon", "value": 1200 }, { "hour": "9am", "weekday": "Mon", "value": 900 }, { "hour": "10am", "weekday": "Mon", "value": 2000 }, { "hour": "11am", "weekday": "Mon", "value": 1100 }, { "hour": "12am", "weekday": "Mon", "value": 2990 }, { "hour": "12pm", "weekday": "Wed", "value": 2990 }, { "hour": "1pm", "weekday": "Wed", "value": 2990 }, { "hour": "2pm", "weekday": "Wed", "value": 1990 }, { "hour": "3pm", "weekday": "Wed", "value": 990 }, { "hour": "4pm", "weekday": "Wed", "value": 2000 }, { "hour": "5pm", "weekday": "Wed", "value": 7890 }, { "hour": "6pm", "weekday": "Wed", "value": 1290 }, { "hour": "7pm", "weekday": "Wed", "value": 1090 }, { "hour": "8pm", "weekday": "Wed", "value": 2990 }, { "hour": "9pm", "weekday": "Wed", "value": 2990 }, { "hour": "10pm", "weekday": "Wed", "value": 2990 }, { "hour": "11pm", "weekday": "Wed", "value": 2990 }, { "hour": "12pm", "weekday": "Wed", "value": 2990 }, { "hour": "1am", "weekday": "Wed", "value": 1890 }, { "hour": "2am", "weekday": "Wed", "value": 1990 }, { "hour": "3am", "weekday": "Wed", "value": 1000 }, { "hour": "4am", "weekday": "Wed", "value": 2100 }, { "hour": "5am", "weekday": "Wed", "value": 2990 }, { "hour": "6am", "weekday": "Wed", "value": 2100 }, { "hour": "7am", "weekday": "Wed", "value": 2990 }, { "hour": "8am", "weekday": "Wed", "value": 1200 }, { "hour": "9am", "weekday": "Wed", "value": 900 }, { "hour": "10am", "weekday": "Wed", "value": 2000 }, { "hour": "11am", "weekday": "Wed", "value": 1100 }, { "hour": "12am", "weekday": "Wed", "value": 2990 }, { "hour": "12pm", "weekday": "Wed", "value": 2990 }, { "hour": "1pm", "weekday": "Thu", "value": 2990 }, { "hour": "2pm", "weekday": "Thu", "value": 1990 }, { "hour": "3pm", "weekday": "Thu", "value": 990 }, { "hour": "4pm", "weekday": "Thu", "value": 2000 }, { "hour": "5pm", "weekday": "Thu", "value": 7890 }, { "hour": "6pm", "weekday": "Thu", "value": 1290 }, { "hour": "7pm", "weekday": "Thu", "value": 1090 }, { "hour": "8pm", "weekday": "Thu", "value": 2990 }, { "hour": "9pm", "weekday": "Thu", "value": 2990 }, { "hour": "10pm", "weekday": "Thu", "value": 2990 }, { "hour": "11pm", "weekday": "Thu", "value": 2990 }, { "hour": "12pm", "weekday": "Thu", "value": 2990 }, { "hour": "1am", "weekday": "Thu", "value": 1890 }, { "hour": "2am", "weekday": "Thu", "value": 1990 }, { "hour": "3am", "weekday": "Thu", "value": 1000 }, { "hour": "4am", "weekday": "Thu", "value": 2100 }, { "hour": "5am", "weekday": "Thu", "value": 2990 }, { "hour": "6am", "weekday": "Thu", "value": 2100 }, { "hour": "7am", "weekday": "Thu", "value": 2990 }, { "hour": "8am", "weekday": "Thu", "value": 1200 }, { "hour": "9am", "weekday": "Thu", "value": 900 }, { "hour": "10am", "weekday": "Thu", "value": 2000 }, { "hour": "11am", "weekday": "Thu", "value": 1100 }, { "hour": "12am", "weekday": "Thu", "value": 2990 }],
            bargraphsession: [{ "name": "Jan", "points": 100 }, { "name": "Feb", "points": 200 }, { "name": "march", "points": 110 }, { "name": "April", "points": 100 }, { "name": "May", "points": 100 }, { "name": "June", "points": 100 }, { "name": "July", "points": 100 }, { "name": "Aug", "points": 100 }, { "name": "Sep", "points": 130 }, { "name": "Oct", "points": 140 }, { "name": "Nov", "points": 200 }, { "name": "Dec", "points": 180 }],
            pieofpiechartdata: [{ "country": "Custom", "litres": 500, "subData": [{ "name": "Add To Cart", "value": 200 }, { "name": "Banner Click", "value": 150 }, { "name": "Internal Banner", "value": 100 }] }, { "country": "Ecommerce", "litres": 300, "subData": [{ "name": "Add To Wishlist", "value": 150 }, { "name": "Banner Click", "value": 100 }, { "name": "Add To Cart", "value": 50 }] }],
            sunbrustchart: [{ "name": "Mobile", "children": [{ "name": "Android", "value": 100 }, { "name": "IOS", "value": 60 }] }, { "name": "Desktop", "children": [{ "name": "Android", "value": 100 }, { "name": "IOS", "value": 60 }] }, { "name": "Tablet", "children": [{ "name": "Android", "value": 100 }, { "name": "IOS", "value": 160 }] }],
            videos: '[{"year":"2009","count":23.5,"type":21.1},{"year":"2010","count":26.2,"type":30.5},{"year":"2011","count":30.1,"type":34.9},{"year":"2012","count":29.5,"type":31.1},{"year":"2013","count":30.6,"type":28.2},{"year":"2014","count":34.1,"type":32.9}]',
            scroll: '',
            searchTermData: [{ "date": "2015-01-01", "ay": 6.5, "aValue": 15 }, { "date": "2015-01-02", "ay": 12.3, "aValue": 8 }, { "date": "2015-01-03", "ay": 12.3, "aValue": 16 }, { "date": "2015-01-04", "ay": 2.8, "aValue": 9 }, { "date": "2015-01-05", "ay": 3.5, "aValue": 5 }, { "date": "2015-01-06", "ay": 5.1, "aValue": 10 }, { "date": "2015-01-07", "ay": 6.7, "aValue": 3 }, { "date": "2015-01-08", "ay": 8, "aValue": 5 }, { "date": "2015-01-09", "ay": 8.9, "aValue": 8 }, { "date": "2015-01-10", "ay": 9.7, "aValue": 15 }, { "date": "2015-01-11", "ay": 10.4, "aValue": 1 }, { "date": "2015-01-12", "ay": 1.7, "aValue": 12 }],
            visibility: false,
            setShow: '',
            isActive: false,
            show: false,
            events: [{ name: "Query", field: "Query", sortable: "false" }, { name: "Clicks", field: "Clicks", sortable: "false" }, { name: "Impressions", filed: "Impressions", sort: true }, { name: "CTR", filed: "CTR", sort: true }, { name: "Position", filed: "Positions", sort: true }],
            landingpage: [{ name: "Landing Page", field: "Landing Page", sortable: "false" }, { name: "Count", field: "Count", sortable: "false" }, { name: "Sales", filed: "Sales", sort: true }, { name: "Bills", filed: "Bills", sort: true }, { name: "ATS", filed: "ATS", sort: true }, { name: "NSU", filed: "NSU", sort: true }, { name: "Top Category", filed: "Top Category", sort: true }, { name: "Top Brand", filed: "Top Brand", sort: true }, { name: "Avg Time Between Purchases", filed: "Avg Time Between Purchases", sort: true }, { name: "Recency", filed: "Recency", sort: true }, { name: "Coupon Penetration", filed: "Coupon Penetration", sort: true }],
            search: [{ name: "Channel Grouping", field: "Channel Grouping", sortable: "false" }, { name: "Event Category", field: "Event Category", sortable: "false" }, { name: "Event Action", filed: "Event Action", sort: true }, { name: "Event Label", filed: "Event Label", sort: true }, { name: "Sessions", filed: "Sessions", sort: true }, { name: "Total Events", filed: "Total Events", sort: true }, { name: "Unique Events", filed: "Unique Events", sort: true }, { name: "Events / Session with Event", filed: "Events / Session with Event", sort: true }, { name: "Transactions", filed: "Transactions", sort: true }, { name: "Revenue", filed: "Revenue", sort: true }, { name: "Average Order Value", filed: "Average Order Value", sort: true }],
            comments: '',
            table_search: [
                { 'name': 'Query', 'field': "query", 'sortable': true },
                { 'name': 'Clicks', 'field': "clicks", 'sortable': true },
                { 'name': 'Impressions', 'field': "impressions", 'sortable': true },
                { 'name': 'CTR', 'field': "ctr", 'sortable': true },
                { 'name': 'Position', 'field': "position", 'sortable': true },

            ],
            table_search_data: [
                { query: 'Add to cart', clicks: 'Mobile', impressions: 's-3', ctr: '24.45', position: '30' },
                { query: 'Add to cart', clicks: 'Mobile', impressions: 's-3', ctr: '24.45', position: '30' },
                { query: 'Add to cart', clicks: 'Mobile', impressions: 's-3', ctr: '24.45', position: '30' },
                { query: 'Add to cart', clicks: 'Mobile', impressions: 's-3', ctr: '24.45', position: '30' },
            ],
            table_header: [
                { 'name': 'Landing page', 'field': "page", 'sortable': true },
                { 'name': 'Users', 'field': "user", 'sortable': true },
                { 'name': 'New Users', 'field': "newuser", 'sortable': true },
                { 'name': 'Sessions', 'field': "sessions", 'sortable': true },
                { 'name': 'Bounce Rate %', 'field': "Bouncerate", 'sortable': true },
                { 'name': 'Average Sessions Duration', 'field': "duration", 'sortable': true },
                { 'name': 'Average pages/session', 'field': "pagesession", 'sortable': true },
                { 'name': 'Sessions With Search', 'field': "sessionssearch", 'sortable': true },
                { 'name': 'Transactions', 'field': "transactions", 'sortable': true },
                { 'name': `Sales(${this.getCountryCurrency()})`, 'field': "sales", 'sortable': true },
                { 'name': 'Conversion Rate', 'field': "conversionrate", 'sortable': true },
                { 'name': 'Average Order Value', 'field': "value", 'sortable': true },
            ],
            table_data: [
                { page: '/?IG=&fbclid=IwAR3bljod2jT4VtPmmZIkqZH56A0WoyAfzu943TwM6QEdixS6XPb2HcaTX-w', user: '3', newuser: '1', sessions: '3', Bouncerate: '0', duration: '0', pagesession: '0', sessionssearch: '0', transactions: '0', sales: '0', conversionrate: '0', cardrate: '25', value: '0' },
                { page: '/?IG=&fbclid=PAAaZwU025GEA64v5_ICijjuGbHLe8VgCi8WWeK4MjbTFZlU3OIbJuyVA2AOE', user: '3', newuser: '1', sessions: '3', Bouncerate: '0', duration: '0', pagesession: '0', sessionssearch: '0', transactions: '0', sales: '0', conversionrate: '0', cardrate: '25', value: '0' },
                { page: '/?fbclid=IwAR01wFFr2x8iqEH-Jvqip17wNyx8ZmlMs1S2EmyBPlbByUsAsYGyEslAva8', user: '3', newuser: '1', sessions: '3', Bouncerate: '0', duration: '0', pagesession: '0', sessionssearch: '0', transactions: '0', sales: '0', conversionrate: '0', cardrate: '25', value: '0' },
            ],
            channel_value: "",
            search_drop_value: '',

            is_matrices_loaded: false,
            is_session_device_loaded: false,
            is_search_by_search_type_loaded: false,
            is_search_table_loaded: false,
            is_piechart_data_loaded: false,
            is_keyword_ranking_loaded: false,
            is_landing_table_loaded: false,
            is_muiltiline_chart_loaded: false,
            is_bubble_graph_data_loaded: false,
            is_organic_landing_loaded: false,


            name: "React",
            shchild1: false,
            is_scroll: false,

            first_start_date: props.start_date,
            first_end_date: props.end_date,
            second_start_date: props.previous_start_date,
            second_end_date: props.previous_end_date,
            isDatePickerOpen: false,
            Deep_Dive_level: 0,
            Deep_Dive_Name: [],
            formatMoney(n) {
                return (Math.round(n * 100) / 100).toLocaleString();
            }

        };
        this.hideComponent = this.hideComponent.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
            this.setState({
                first_start_date: nextProps.start_date,
                first_end_date: nextProps.end_date,
                second_start_date: nextProps.previous_start_date,
                second_end_date: nextProps.previous_end_date,
            });
        }
    }

    componentDidMount() {
        this.getMetricesCard();
        this.getSessionbyDevice();
        this.getSearchbySearchType();
        this.getSearchQueriesTable();
        this.getPieChart();
        this.getKeywordRankings();
        this.getLandingPageTable();
        this.getMultilineChart();
        this.getSearchTermsBubbleGraph();
        this.getOrganicLandingPage();
        //this.onClickRiExport();

        window.addEventListener("scroll", this.handleScroll);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.start_date !== this.props.start_date ||
            prevProps.end_date !== this.props.end_date ||
            prevProps.previous_start_date !== this.props.previous_start_date ||
            prevProps.previous_end_date !== this.props.previous_end_date
        ) {

            this.setState({
                is_matrices_loaded: false,
                is_session_device_loaded: false,
                is_search_by_search_type_loaded: false,
                is_search_table_loaded: false,
                is_keyword_ranking_loaded: false,
                is_landing_table_loaded: false,
                is_muiltiline_chart_loaded: false,
                is_organic_landing_loaded: false,
                is_bubble_graph_data_loaded: false,
                is_piechart_data_loaded: false,

            })

            this.getMetricesCard();
            this.getSessionbyDevice();
            this.getSearchbySearchType();
            this.getSearchQueriesTable();
            this.getPieChart();
            this.getKeywordRankings();
            this.getLandingPageTable();
            this.getMultilineChart();
            this.getSearchTermsBubbleGraph();
            this.getOrganicLandingPage();
        }
    }

    getMetricesCard() {
        let start_date = this.state.first_start_date;
        let end_date = this.state.first_end_date;
        let previous_start_date = this.state.second_start_date;
        let previous_end_date = this.state.second_end_date;
        let channel = this.state.channel_value;

        const url = API_URL_1 + "/api/ecom/earned-matric/";
        fetch(url, {
            method: 'POST',
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&last_start_date=" + previous_start_date +
                "&last_end_date=" + previous_end_date +
                "&channel=" + channel,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': ' Bearer ' + localStorage.getItem("token")
            },
        }).then(res => res.json()
        ).then((result) => {


            let current_avg_order_value;
            let last_avg_order_value;
            let current_revenue;
            let last_revenue;
            let current_bounce_rate;
            let last_bounce_rate;
            let current_conversion_rate;
            let last_conversion_rate;
            let current_ctr;
            let last_ctr;



            let current_transaction_revenue = (result['earned_current_matric_list'][0]['transaction_revenue']) ? (result['earned_current_matric_list'][0]['transaction_revenue']) : 0
            let last_transaction_revenue = (result['earned_last_matric_list'][0]['transaction_revenue']) ? (result['earned_last_matric_list'][0]['transaction_revenue']) : 0

            let current_session = (result['earned_current_matric_list'][0]['session']) ? (result['earned_current_matric_list'][0]['session']) : 0
            let last_session = (result['earned_last_matric_list'][0]['session']) ? (result['earned_last_matric_list'][0]['session']) : 0

            let current_user = (result['earned_current_matric_list'][0]['users']) ? (result['earned_current_matric_list'][0]['users']) : 0
            let last_user = (result['earned_last_matric_list'][0]['users']) ? (result['earned_last_matric_list'][0]['users']) : 0

            let current_bounce = (result['earned_current_matric_list'][0]['bounce']) ? (result['earned_current_matric_list'][0]['bounce']) : 0
            let last_bounce = (result['earned_last_matric_list'][0]['bounce']) ? (result['earned_last_matric_list'][0]['bounce']) : 0

            current_bounce_rate = ((current_bounce / current_session) * 100) ? ((current_bounce / current_session) * 100) : 0
            last_bounce_rate = ((last_bounce / last_session) * 100) ? ((last_bounce / last_session) * 100) : 0

            let current_transaction = (result['earned_current_matric_list'][0]['transactions']) ? (result['earned_current_matric_list'][0]['transactions']) : 0
            let last_transaction = (result['earned_last_matric_list'][0]['transactions']) ? (result['earned_last_matric_list'][0]['transactions']) : 0

            current_conversion_rate = ((current_transaction / current_session) * 100) ? ((current_transaction / current_session) * 100) : 0
            last_conversion_rate = ((last_transaction / last_session) * 100) ? ((last_transaction / last_session) * 100) : 0

            let current_impression = (result['current_clicks_list'][0]['impressions']) ? (result['current_clicks_list'][0]['impressions']) : 0
            let last_impression = (result['last_clicks_list'][0]['impressions']) ? (result['last_clicks_list'][0]['impressions']) : 0



            if (isNaN(parseInt(result['current_clicks_list'][0]['clicks']))) { result['current_clicks_list'][0]['clicks'] = 0 }

            let current_click = (result['current_clicks_list'][0]['clicks']) ? (result['current_clicks_list'][0]['clicks']) : 0

            let last_click = (result['last_clicks_list'][0]['clicks']) ? (result['last_clicks_list'][0]['clicks']) : 0


            // current_revenue = (current_transaction_revenue / current_transaction) ?(current_transaction_revenue / current_transaction):0
            // last_revenue = (last_transaction_revenue / last_transaction)? (last_transaction_revenue / last_transaction):0

            current_avg_order_value = (current_transaction_revenue / current_transaction) ? (current_transaction_revenue / current_transaction) : 0
            last_avg_order_value = (last_transaction_revenue / last_transaction) ? (last_transaction_revenue / last_transaction) : 0

            current_ctr = ((current_click / current_impression) * 100) ? ((current_click / current_impression) * 100) : 0
            last_ctr = ((last_click / last_impression) * 100) ? ((last_click / last_impression) * 100) : 0


            let current_keyword = (result['currnet_impression_click_list'][0]['keywords']) ? (result['currnet_impression_click_list'][0]['keywords']) : 0
            let last_keyword = (result['last_impression_click_list'][0]['keywords']) ? (result['last_impression_click_list'][0]['keywords']) : 0



            //    FOR SPARKLINE LIST
            let matrices_sparkline_list = result['earned_sparkline_list']

            let revenue_list = [];
            let transaction_list = [];
            let avg_order_value_list = [];
            let sessions_list = [];
            let user_list = [];
            let bounce_rate_lits = [];
            let conversion_rate_list = [];
            let impressions_list = [];
            let click_list = [];
            let ctr_list = [];
            let keyword_list = [];

            // ctr:
            // total_ctr === "NaN" || total_ctr === "Infinity"
            //   ? "0"
            //   : total_ctr,
            matrices_sparkline_list.map((info, index) => {
                try {
                    let revenue = {
                        'date': info['date'],
                        'value': info['transaction_revenue']
                    }
                    revenue_list.push(revenue)

                    let avg = info['transaction_revenue'] || 0 / info['transactions'] || 0

                    let avg_order_value = {
                        'date': info['date'],
                        'value': avg === 'NaN' || avg === 'Infinity' ? "0" : avg,

                    }
                    // ctr: total_ctr === "NaN" || total_ctr === "Infinity" ? "0": total_ctr,

                    avg_order_value_list.push(avg_order_value)

                    let transaction = {
                        'date': info['date'],
                        'value': info['transactions']
                    }
                    transaction_list.push(transaction)

                    let session = {
                        'date': info['date'],
                        'value': info['session']
                    }
                    sessions_list.push(session)
                    let user = {
                        'date': info['date'],
                        'value': info['users']

                    }
                    user_list.push(user)

                    let bounce = {
                        'date': info['date'],
                        'value': (info['bounce'] / info['session'])

                    }
                    bounce_rate_lits.push(bounce)
                    let conversion = {
                        'date': info['date'],
                        'value': ((info['transactions'] / info['session']) * 100).toFixed(2)

                    }
                    conversion_rate_list.push(conversion)
                } catch (e) {

                }

            })
            let impressionslist_date = result['sparkiline_clicks_list']

            impressionslist_date.map((info, index) => {
                try {
                    let impressions = {
                        'date': info['date'],
                        'value': info['impressions'],
                    }
                    impressions_list.push(impressions)

                    let click = {
                        'date': info['date'],
                        'value': info['clicks'],
                    }
                    click_list.push(click)
                    let ctr = {
                        'date': info['date'],
                        'value': (info['clicks'] / info['impressions'] * 100).toFixed(2),
                    }
                    ctr_list.push(ctr)



                } catch (e) {

                }


            })
            let sparkline_impression_click_list = result['sparkline_impression_click_list']
            sparkline_impression_click_list.map((info, index) => {
                try {
                    let keyword = {
                        'date': info['date'],
                        'value': info['keywords'],
                    }
                    keyword_list.push(keyword)

                }

                catch {



                }
            })

            this.setState({
                is_matrices_loaded: true,
                current_session: current_session,
                last_session: last_session,
                current_user: current_user,
                last_user: last_user,
                current_bounce_rate: current_bounce_rate,
                last_bounce_rate: last_bounce_rate,
                current_conversion_rate: current_conversion_rate,
                last_conversion_rate: last_conversion_rate,
                current_impression: current_impression,
                last_impression: last_impression,
                current_click: current_click,
                last_click: last_click,
                current_ctr: current_ctr,
                last_ctr: last_ctr,
                current_revenue: current_revenue,
                last_revenue: last_revenue,
                current_transaction: current_transaction,
                last_transaction: last_transaction,
                current_avg_order_value: current_avg_order_value,
                last_avg_order_value: last_avg_order_value,
                current_keyword: current_keyword,
                last_keyword: last_keyword,
                current_transaction_revenue: current_transaction_revenue,
                last_transaction_revenue: last_transaction_revenue,


                // SPARKILINE SETSTATE
                session_graph: sessions_list,
                user_graph: user_list,
                bounce_rate_graph: bounce_rate_lits,
                conversion_rate_graph: conversion_rate_list,
                impressions_graph: impressions_list,
                click_graph: click_list,
                ctr_graph: ctr_list,
                revenue_graph: revenue_list,
                avg_order_value_graph: avg_order_value_list,
                transaction_graph: transaction_list,
                keyword_graph: keyword_list,


            })


        });

    }

    getMultilineChart() {
        let start_date = this.state.first_start_date;
        let end_date = this.state.first_end_date;
        let previous_start_date = this.state.second_start_date;
        let previous_end_date = this.state.second_end_date;
        let channel = this.state.channel_value;
        let multiline = [];
        const url = API_URL_1 + "/api/ecom/multiple-line-chart/";
        fetch(url, {
            method: 'POST',
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&last_start_date=" + previous_start_date +
                "&last_end_date=" + previous_end_date +
                "&channel=" + channel,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': ' Bearer ' + localStorage.getItem("token")
            },
        }).then(res => res.json()).then((result) => {
            let multiline_chart_list = result['multiline_chart_list']
            let multiline = [];
            multiline_chart_list.map((info, index) => {
                try {
                    let a = {
                        'direct': (info['direct_session'] != null && info['direct_session'] != undefined) ? info['direct_session'] : 0,
                        'orgainc_search': (info['organic_search_session'] != null && info['organic_search_session'] != undefined) ? info['organic_search_session'] : 0,
                        'referrals': (info['referrals_session'] != null && info['referrals_session'] != undefined) ? info['referrals_session'] : 0,
                        'social': (info['social_session'] != null && info['social_session'] != undefined) ? info['social_session'] : 0,
                        'year': info['date']
                    }
                    multiline.push(a)
                } catch (e) {
                }
            })


            this.setState({
                is_muiltiline_chart_loaded: true,
                multiline_chart_data: multiline,

            })

        })




    };

    getSessionbyDevice() {
        let start_date = this.state.first_start_date;
        let end_date = this.state.first_end_date;
        let previous_start_date = this.state.second_start_date;
        let previous_end_date = this.state.second_end_date;
        let channel = this.state.channel_value;

        const url = API_URL_1 + "/api/ecom/session-device/";
        fetch(url, {
            method: 'POST',
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&last_start_date=" + previous_start_date +
                "&last_end_date=" + previous_end_date +
                "&channel=" + channel,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': " Bearer " + localStorage.getItem("token")
            },
        }).then(res => res.json()).then((result) => {
            let device_list = result['device_list']

            let devices = []
            device_list.map((info) => {
                if (!devices.includes(info['device'])) {
                    devices.push(info['device'])
                }
            })

            let os_list = []
            devices.map((device_type) => {
                let childrens = []
                device_list.map((info) => {
                    if (device_type == info['device']) {
                        childrens.push({ "name": info['operating_system'], "value": info['total_session'] })
                    }
                })
                let d = { "name": device_type.charAt(0).toUpperCase() + device_type.slice(1).toLowerCase(), "children": childrens }
                os_list.push(d)
            })

            this.setState({
                is_session_device_loaded: true,
                sesion_device_graph: os_list,


            })



        })


    }

    getSearchbySearchType() {
        let start_date = this.state.first_start_date;
        let end_date = this.state.first_end_date;
        let previous_start_date = this.state.second_start_date;
        let previous_end_date = this.state.second_end_date;
        let channel = this.state.channel_value;
        const url = API_URL_1 + "/api/ecom/searchby-searchtype/";
        fetch(url, {
            method: 'POST',
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&last_start_date=" + previous_start_date +
                "&last_end_date=" + previous_end_date +
                "&channel=" + channel,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': ' Bearer ' + localStorage.getItem('token')
            },
        }).then(res => res.json()).then((result) => {


            let search_by_search_type_list = result['search_by_search_type_list']
            let search_by_lits = [];

            search_by_search_type_list.map((info, index) => {
                try {
                    let ctr = ((info['clicks'] / info['impressions']) * 100).toFixed(2)
                    let a = {
                        'year': info['search_type'],
                        'count': info[this.state.search_type],
                        'type': ctr
                    }
                    search_by_lits.push(a)

                } catch (e) { }



            });
            this.setState({
                is_search_by_search_type_loaded: true,
                search_by_graph: search_by_lits,


            });




        });


    }

    getSearchQueriesTable() {
        let start_date = this.state.first_start_date;
        let end_date = this.state.first_end_date;
        let previous_start_date = this.state.second_start_date;
        let previous_end_date = this.state.second_end_date;
        let channel = this.state.channel_value;

        const url = API_URL_1 + "/api/ecom/search-queries-table/";
        fetch(url, {
            method: 'POST',
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&last_start_date=" + previous_start_date +
                "&last_end_date=" + previous_end_date +
                "&channel=" + channel,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': ' Bearer ' + localStorage.getItem('token')
            },
        }).then(res => res.json()).then((result) => {


            let search_table_list = result['search_table_list']
            let table_date_list = [];
            search_table_list.map((info, index) => {
                let ctr = parseFloat((info['clicks'] / info['impressions']) * 100).toFixed(2)

                try {
                    let table = {
                        'query': info['keywords'],
                        'clicks': info['clicks'],
                        'impressions': info['impressions'],
                        'ctr': ctr,
                        'position': info['positions']

                    }
                    table_date_list.push(table)


                } catch (e) {

                }

            })
            this.setState({
                is_search_table_loaded: true,
                table_date_graph: table_date_list,
            })



        })

    }

    getPieChart() {
        let start_date = this.state.first_start_date;
        let end_date = this.state.first_end_date;
        let previous_start_date = this.state.second_start_date;
        let previous_end_date = this.state.second_end_date;

        const url = API_URL_1 + "/api/ecom/channel-group-chart/";

        fetch(url, {
            method: 'POST',
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&last_start_date=" + previous_start_date +
                "&last_end_date=" + previous_end_date,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': ' Bearer ' + localStorage.getItem('token')
            },
        }).then(res => res.json()).then((result) => {

            let piechart_list = result['channels']

            let pie_list = [];
            piechart_list.map((info, index) => {


                try {
                    let pie = {
                        'name': info['channel_name'],
                        'value': info['session']
                    }
                    pie_list.push(pie)

                } catch (e) {


                }
            })
            this.setState({
                is_piechart_data_loaded: true,
                pie_list_graph: pie_list,



            })

        })

    }
    getKeywordRankings() {
        let start_date = this.state.first_start_date;
        let end_date = this.state.first_end_date;
        let previous_start_date = this.state.second_start_date;
        let previous_end_date = this.state.second_end_date;
        let channel = this.state.channel_value;

        const url = API_URL_1 + "/api/ecom/keyword-ranking/";
        fetch(url, {
            method: 'POST',
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&last_start_date=" + previous_start_date +
                "&last_end_date=" + previous_end_date +
                "&channel=" + channel,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': ' Bearer ' + localStorage.getItem('token')
            },
        }).then(res => res.json()).then((result) => {
            let keyword_rankings_list = result['key_ranking__list']
            let keyword_lits = [];
            // [{ "name": "Top-10", "points": 100 },

            keyword_rankings_list.map((info, index) => {
                try {
                    let keyword = {
                        'name': info['position'],
                        'points': info['count']
                    }
                    keyword_lits.push(keyword)


                } catch (e) {


                }


            })
            this.setState({
                is_keyword_ranking_loaded: true,
                keyword_graph: keyword_lits,



            })





        })
    }
    getLandingPageTable() {
        let start_date = this.state.first_start_date;
        let end_date = this.state.first_end_date;
        let previous_start_date = this.state.second_start_date;
        let previous_end_date = this.state.second_end_date;
        let channel = this.state.channel_value;


        const url = API_URL_1 + "/api/ecom/organic-landing-table/";
        fetch(url, {
            method: 'POST',
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&last_start_date=" + previous_start_date +
                "&last_end_date=" + previous_end_date +
                "&channel=" + channel,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': ' Bearer ' + localStorage.getItem('token')
            },
        }).then(res => res.json()).then((result) => {
            let landing_table_list = result['landing_table_list']

            let table_data = [];
            landing_table_list.map((info, index) => {
                let search_with_session = parseFloat((info['search_session'] / info['session']) * 100).toFixed(2)
                let avg_page_per_session = parseFloat(info['page_views'] / info['session']).toFixed(2)
                try {
                    if (isNaN(parseFloat(search_with_session))) {
                        search_with_session = 0

                    }
                    else if ((parseFloat(search_with_session) === Infinity)) {
                        search_with_session = 0
                    }

                    let a = {
                        'page': (info['landing_page'] ? info['landing_page'] : 0),
                        'user': (info['users'] ? info['users'] : 0),
                        'newuser': (info['newuser'] ? info['newuser'] : 0),
                        'sessions': (info['session'] ? info['session'] : 0),
                        'Bouncerate': (info['bounce'] * 100 ? info['bounce'] : 0),
                        'duration': (info['session_duration_in_seconds'] ? info['session_duration_in_seconds'] : 0),
                        'pagesession': (avg_page_per_session ? avg_page_per_session : 0),
                        'sessionssearch': search_with_session,
                        'transactions': (info['transactions'] ? info['transactions'] : 0),
                        'sales': this.state.formatMoney(info['transaction_revenue'].toFixed(2)),
                        'conversionrate': (parseFloat(info['transactions'] / info['session'],) ? parseFloat(info['transactions'] / info['session'],) : 0).toFixed(2),
                        'value': (info['transaction_revenue'] / info['transactions'] ? info['transaction_revenue'] / info['transactions'] : 0).toFixed(2)
                    }
                    table_data.push(a)

                } catch (e) {

                }

            })
            this.setState({
                is_landing_table_loaded: true,
                table_graph: table_data,
            })
        })

    }
    getSearchTermsBubbleGraph() {
        let start_date = this.state.first_start_date;
        let end_date = this.state.first_end_date;
        let previous_start_date = this.state.second_start_date;
        let previous_end_date = this.state.second_end_date;
        let channel = this.state.channel_value;

        const url = API_URL_1 + "/api/ecom/search-queries/"
        fetch(url, {
            method: 'POST',
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&last_start_date=" + previous_start_date +
                "&last_end_date=" + previous_end_date +
                "&channel=" + channel,

            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': ' Bearer ' + localStorage.getItem('token')
            },
        }

        )
            .then(res => res.json())
            .then((result) => {
                let query_list = result['search_query_list']
                let data_list = [];
                query_list.map((info, index) => {
                    try {
                        let a = {
                            "date": info['clicks'],
                            "ay": info['impressions'],
                            "aValue": ((info['clicks'] / info['impressions']) * 100).toFixed(2),
                            "bubbleLabelText": info['keywords'],

                        }
                        data_list.push(a);
                    } catch {

                    }

                })

                this.setState({
                    is_bubble_graph_data_loaded: true,
                    search_terms_bubble_graph: data_list



                });
            },
                (error) => {
                }
            )

    }

    getOrganicLandingPage() {
        let start_date = this.state.first_start_date;
        let end_date = this.state.first_end_date;
        let previous_start_date = this.state.second_start_date;
        let previous_end_date = this.state.second_end_date;
        let channel = this.state.channel_value;

        // Deep Dives Filter
        let Deep_Dive_level = this.state.Deep_Dive_level;
        let Deep_Dive_Name = this.state.Deep_Dive_Name;


        const url = API_URL_1 + "/api/ecom/oraganic-landing-chart/"
        fetch(url, {
            method: 'POST',
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&last_start_date=" + previous_start_date +
                "&last_end_date=" + previous_end_date +
                "&channel=" + channel +
                "&level=" + Deep_Dive_level +
                "&name=" + Deep_Dive_Name,

            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': ' Bearer ' + localStorage.getItem('token')
            },
        }

        )
            .then(res => res.json())
            .then((result) => {
                let organic_list = result

                if (organic_list.length == 0) {
                    this.setState({ 'treegraph': [], 'Deep_Dive_level': 0, 'Deep_Dive_Name': [], 'is_organic_landing_loaded': false });
                }


                if ((organic_list.length != [])) {

                    this.setState({
                        treegraph: organic_list,
                        is_organic_landing_loaded: true,
                    });
                } else {

                    this.setState({
                        Deep_Dive_level: Deep_Dive_level,
                        is_organic_landing_loaded: true,
                    });
                }


            });



    }

    hideComponent(varname) {

        switch (varname) {
            case "shchild1":
                this.setState({ shchild1: !this.state.shchild1 });
                break;
            default: return;
        }
    }

    handlePieclick = (childData) => {
        if (this.state.pie_click_data === childData) {
            this.state.pie_click_data = ""
        } else {
            this.state.pie_click_data = childData;
        }
        this.state.trafficeChannel = childData;

        this.setState({

            is_matrices_loaded: false,
            is_session_device_loaded: false,
            is_search_by_search_type_loaded: false,
            is_search_table_loaded: false,
            is_keyword_ranking_loaded: false,
            is_landing_table_loaded: false,
            is_muiltiline_chart_loaded: false,
            is_organic_landing_loaded: false,
            is_bubble_graph_data_loaded: false,

        })

        // FUNCTION
        this.getMetricesCard();
        this.getSessionbyDevice();
        this.getSearchbySearchType();
        this.getSearchQueriesTable();
        this.getKeywordRankings();
        this.getLandingPageTable();
        this.getMultilineChart();
        this.getOrganicLandingPage();
        this.getSearchTermsBubbleGraph();
    }


    treemapparentCallback = (childData) => {

        let DeepDiveBreadCrumb = this.state.Deep_Dive_Name;

        DeepDiveBreadCrumb.push(childData.replace('&', '~andtoreplace~'));
        this.state.Deep_Dive_Name = DeepDiveBreadCrumb;
        this.state.Deep_Dive_level = DeepDiveBreadCrumb.length;

        this.setState({ 'is_organic_landing_loaded': false })

        // this.state.is_organic_landing_loaded = false;

        this.getOrganicLandingPage();
        this.forceUpdate();
    }


    treemapparentCallback2 = (childData) => {


        let DeepDiveBreadCrumb = this.state.Deep_Dive_Name;
        var removed = DeepDiveBreadCrumb.splice(childData);

        this.state.Deep_Dive_Name = DeepDiveBreadCrumb;
        this.state.Deep_Dive_level = DeepDiveBreadCrumb.length;

        if (DeepDiveBreadCrumb.length <= 9) {
            this.state.is_organic_landing_loaded = false;
            this.getOrganicLandingPage();
            this.forceUpdate();
        } else {
            alert('Maximum level reached');
        }


    }



    handleCallback = (childData) => {
        this.setState({ daily_metrics_name: childData, is_daily_data_loaded: false });
    }
    searchbysearchhandleCallback = (childData) => {
        this.state.search_type = childData
        this.setState({
            is_search_by_search_type_loaded: false,

        })
        this.getSearchbySearchType();
    }
    handletrafficCallback = (childData) => {
        this.setState({ trafficdropdown_options: childData, is_traffic_word_data_loaded: false });
    }
    handledatatableCallback = (childData) => {
        this.setState({ datatabledropdown_options: childData, is_datatable_word_data_loaded: false });
    }

    searchShow = () => {
        this.setState({
            show: true
        });
        this.scrollSearch.current.scrollIntoView({ behavior: "smooth" });
    }

    searchHide = () => {
        this.setState({
            show: false
        })
    }

    eventShow = () => {
        this.setState({
            isActive: true
        });
        this.scrollDiv.current.scrollIntoView({ behavior: "smooth" });
    }

    eventHide = () => {
        this.setState({
            isActive: false
        })
    }

    datepickerHandleCallback = (childData) => {
        this.state.first_start_date = childData[0];
        this.state.first_end_date = childData[1];
        this.state.second_start_date = childData[2];
        this.state.second_end_date = childData[3];

        this.state.is_matrices_loaded = false;
        this.state.is_session_device_loaded = false;
        this.state.is_search_by_search_type_loaded = false;
        this.state.is_search_table_loaded = false;
        this.state.is_piechart_data_loaded = false;
        this.state.is_keyword_ranking_loaded = false;
        this.state.is_landing_table_loaded = false;
        this.state.is_organic_landing_loaded = false;

        // FUNCTION

        this.getMetricesCard();
        this.getSessionbyDevice();
        this.getSearchbySearchType();
        this.getSearchQueriesTable();
        this.getPieChart();
        this.getKeywordRankings();
        this.getLandingPageTable();
        this.getOrganicLandingPage()




        this.datepickerHandleCallback2();
        this.forceUpdate();
    };

    datepickerHandleCallback2 = () => {
        this.setState({ isDatePickerOpen: !this.state.isDatePickerOpen });
    };

    handleScroll = () => {
        if (window.pageYOffset > 1) {
            if (!this.state.is_scroll) {
                this.setState({ is_scroll: true });
            }
        } else {
            if (this.state.is_scroll) {
                this.setState({ is_scroll: false });
            }
        }
    };



    render() {

        const CarouselSettings = {
            arrows: true,
            dots: false,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            initialSlide: 0,
            responsive: [

                {
                    breakpoint: 1202,
                    settings: {
                        arrows: true,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,

                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,

                    }
                }
            ]
        }

        return (
            <Wrapper>

                <div className="grid grid_cols_4 drawer_grid ri_summary_bsImport">
                    <div className="left_drawer col_span_1 fixed-left-grid mapRightWrapper">
                        <div className="icz-rimapsection bg-white">
                            <Col sm={12} className="icz-cardheader p-20 d-flex">
                                <Col className="icz-cardtitle">
                                    <div className="icz-title-wrap p-0">
                                        <div className="text-left">
                                            <h5 className="icz-cardtitle text-start mb-0">Traffic By Traffic Channel</h5>
                                        </div>
                                    </div>
                                </Col>
                            </Col>
                            {this.state.is_piechart_data_loaded == true ?
                                <div className="h-100 d-flex justify-content-center align-items-center">
                                    <Piechart card_id="icz-traffic-piechart" card_class="icz-leftsectionchart" graph-data={this.state.pie_list_graph} parentCallback={this.handlePieclick} />
                                </div>
                                : <Loader />}
                        </div>
                    </div>
                    <div className="right_side col_span_3 relative-right-grid icz-ridatacontainer">
                        <div className="content">
                            <div className="content_section">
                                <PageHeader pageTitle={"Earned"} />
                                <div className="page_content">
                                    <div className="grid grid_cols_1 dashboard_home">
                                        {this.state.trafficeChannel === '' ? '' :
                                            <div className="icz-title-wrap d-flex">
                                                <Col sm={12}>
                                                    <div className="icz-row">
                                                        <Col><h5 className="icz-card-title align-items-start">{this.state.trafficeChannel}</h5></Col>
                                                    </div>
                                                </Col>
                                            </div>
                                        }

                                        <div className='grid grid_cols_1'>
                                            <div className="grid col_span_4 icz-carouselcontainer">
                                                {this.state.is_matrices_loaded == true ?
                                                    <Carousel
                                                        Settings={CarouselSettings}
                                                        class={"icz-cardcontainer"}
                                                        SliderCards={[
                                                            <ChartCard
                                                                index="1"
                                                                CardClass="icz-cardwrapper"
                                                                CardIcon={<IconWebsite className="icz-icon" />}
                                                                CardTitle="Sessions"
                                                                RowOneCurrentValue={this.state.current_session}
                                                                RowOnePreviousValue={this.state.last_session}
                                                                RowOneTitle="earned"
                                                                IsNumber={'number'}
                                                                IsStandard={true}
                                                                chart={<Linegraph_sparkline card_id="icz-sessions" card_class="icz-cardchart" graph-data={this.state.session_graph} />}
                                                            />,

                                                            <ChartCard
                                                                index="2"
                                                                CardClass="icz-cardwrapper"
                                                                CardIcon={<IconWebsite className="icz-icon" />}
                                                                CardTitle="Users"
                                                                RowOneCurrentValue={this.state.current_user}
                                                                RowOnePreviousValue={this.state.last_user}
                                                                RowOneTitle="earned"
                                                                IsNumber={'number'}
                                                                IsStandard={true}
                                                                chart={<Linegraph_sparkline card_id="icz-sessions-users" card_class="icz-cardchart" graph-data={this.state.user_graph} />}
                                                            />,
                                                            <ChartCard
                                                                index="3"
                                                                CardClass="icz-cardwrapper"
                                                                CardIcon={<IconWebsite className="icz-icon" />}
                                                                CardTitle="Bounce Rate"
                                                                RowOneCurrentValue={parseFloat(this.state.current_bounce_rate).toFixed(2)}
                                                                RowOnePreviousValue={parseFloat(this.state.last_bounce_rate).toFixed(2)}
                                                                RowOneTitle="earned"
                                                                IsNumber={'percentage'}
                                                                IsStandard={false}
                                                                chart={<Linegraph_sparkline card_id="icz-bounce-rate" isnumber={"percentage"} card_class="icz-cardchart" graph-data={this.state.bounce_rate_graph} />}
                                                            />,
                                                            <ChartCard
                                                                index="4"
                                                                CardClass="icz-cardwrapper"
                                                                CardIcon={<IconWebsite className="icz-icon" />}
                                                                CardTitle="Conversion Rate"
                                                                RowOneCurrentValue={parseFloat(this.state.current_conversion_rate).toFixed(2)}
                                                                RowOnePreviousValue={parseFloat(this.state.last_conversion_rate).toFixed(2)}
                                                                RowOneTitle="earned"
                                                                IsStandard={true}
                                                                IsNumber={'percentage'}
                                                                chart={<Linegraph_sparkline card_id="icz-exits" isnumber={"decimal_percentage"} card_class="icz-cardchart" graph-data={this.state.conversion_rate_graph} />}
                                                            />,

                                                            <ChartCard
                                                                index="5"
                                                                CardClass="icz-cardwrapper"
                                                                CardIcon={<IconWebsite className="icz-icon" />}
                                                                CardTitle="Impressions"
                                                                RowOneCurrentValue={this.state.current_impression}
                                                                RowOnePreviousValue={this.state.last_impression}
                                                                RowOneTitle="earned"
                                                                IsNumber={'number'}
                                                                IsStandard={true}
                                                                chart={<Linegraph_sparkline card_id="icz-impressions" card_class="icz-cardchart" graph-data={this.state.impressions_graph} />}
                                                            />,

                                                            <ChartCard
                                                                index="6"
                                                                CardClass="icz-cardwrapper"
                                                                CardIcon={<IconWebsite className="icz-icon" />}
                                                                CardTitle="Clicks"
                                                                RowOneCurrentValue={this.state.current_click}
                                                                RowOnePreviousValue={this.state.last_click}
                                                                RowOneTitle="earned"
                                                                IsNumber={'number'}
                                                                IsStandard={true}
                                                                chart={<Linegraph_sparkline card_id="icz-clicks" card_class="icz-cardchart" graph-data={this.state.click_graph} />}
                                                            />,
                                                            <ChartCard
                                                                index="7"
                                                                CardClass="icz-cardwrapper"
                                                                CardIcon={<IconWebsite className="icz-icon" />}
                                                                CardTitle="Click Through Rate"
                                                                RowOneCurrentValue={parseFloat(this.state.current_ctr).toFixed(2)}
                                                                RowOnePreviousValue={parseFloat(this.state.last_ctr).toFixed(2)}
                                                                RowOneTitle="earned"
                                                                IsNumber={'percentage'}
                                                                IsStandard={true}
                                                                chart={<Linegraph_sparkline card_id="icz-click-rate" isnumber={"decimal_percentage"} card_class="icz-cardchart" graph-data={this.state.ctr_graph} />}
                                                            />,
                                                            <ChartCard
                                                                index="8"
                                                                CardClass="icz-cardwrapper"
                                                                CardIcon={<IconWebsite className="icz-icon" />}
                                                                CardTitle="#Of Keywords in Top 100"
                                                                RowOneCurrentValue={this.state.current_keyword}
                                                                RowOnePreviousValue={this.state.last_keyword}
                                                                RowOneTitle="earned"
                                                                IsNumber={'number'}
                                                                IsStandard={true}
                                                                chart={<Linegraph_sparkline card_id="icz-keywordstop" card_class="icz-cardchart" graph-data={this.state.keyword_graph} />}
                                                            />,
                                                            <ChartCard
                                                                index="9"
                                                                CardClass="icz-cardwrapper"
                                                                CardIcon={<IconWebsite className="icz-icon" />}
                                                                CardTitle="Revenue"
                                                                RowOneCurrentValue={parseFloat(this.state.current_transaction_revenue).toFixed(2)}
                                                                RowOnePreviousValue={parseFloat(this.state.last_transaction_revenue).toFixed(2)}
                                                                RowOneTitle="earned"
                                                                IsNumber={'money'}
                                                                IsStandard={true}
                                                                chart={<Linegraph_sparkline card_id="icz-organicsessions" card_class="icz-cardchart" graph-data={this.state.revenue_graph} />}
                                                            />,

                                                            <ChartCard
                                                                index="10"
                                                                CardClass="icz-cardwrapper"
                                                                CardIcon={<IconWebsite className="icz-icon" />}
                                                                CardTitle="Transactions"
                                                                RowOneCurrentValue={parseFloat(this.state.current_transaction).toFixed(2)}
                                                                RowOnePreviousValue={parseFloat(this.state.last_transaction).toFixed(2)}
                                                                RowOneTitle="earned"
                                                                IsNumber={'number'}
                                                                IsStandard={true}
                                                                chart={<Linegraph_sparkline card_id="icz-organic-users" card_class="icz-cardchart" graph-data={this.state.transaction_graph} />}
                                                            />,
                                                            <ChartCard
                                                                index="11"
                                                                CardClass="icz-cardwrapper"
                                                                CardIcon={<IconWebsite className="icz-icon" />}
                                                                CardTitle="Average Order Value"
                                                                RowOneCurrentValue={parseFloat(this.state.current_avg_order_value).toFixed(2)}
                                                                RowOnePreviousValue={parseFloat(this.state.last_avg_order_value).toFixed(2)}
                                                                RowOneTitle="earned"
                                                                IsNumber={'money'}
                                                                IsStandard={true}
                                                                chart={<Linegraph_sparkline card_id="icz-organicbounce-rate" card_class="icz-cardchart" graph-data={this.state.avg_order_value_graph} />}
                                                            />,

                                                        ]}>

                                                    </Carousel>
                                                    : <Loader />}
                                            </div>
                                        </div>


                                        <div className="icz-row">

                                            <Col className="icz-sectioncardwrapper" sm={12} lg={12}>
                                                <div className="icz-sectioncard">
                                                    <Col sm={12} className="icz-cardheader flex-wrap justify-content-between">
                                                        <Col className="icz-cardtitle">
                                                            Traffic By Channel
                                                        </Col>
                                                        <Col className="icz-cardfilter">
                                                            <div className="icz-cardbtnwrapper icz-chartexport">
                                                                <ChartExport
                                                                    ChartId='trafficByChannel'
                                                                    export_data={this.state.multiline_chart_data}
                                                                    downloadName="Traffic By Channel"
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Col>

                                                    {this.state.is_muiltiline_chart_loaded ?
                                                        <div className="">
                                                            <FourLine_LineChart chart_id="trafficByChannel" chart_class="icz-sectionchart"
                                                                graph-data={this.state.multiline_chart_data}
                                                                metric_1={'Direct'} metric_2={'Organic Search'}
                                                                metric_3={'Referrals'} metric_4={'Social'} metric_5={''}
                                                                value1={'direct'} value2={'orgainc_search'}
                                                                value3={'referrals'} value4={'social'} />

                                                        </div>
                                                        : ""}

                                                </div>
                                            </Col>
                                        </div>

                                        <div className="grid grid_cols_4 icz-row">
                                            <div className="grid col_span_2 icz-sectioncardwrapper">
                                                <div className="icz-sectioncard">
                                                    <div className="icz-cardheader flex-wrap justify-content-between">
                                                        <div className="icz-cardtitle">
                                                            Sessions By Device
                                                        </div>
                                                        <div className="icz-cardfilter">
                                                            <div className="icz-cardbtnwrapper icz-chartexport">
                                                                <ChartExport
                                                                    ChartId='sessionsByDevice'
                                                                    export_data={this.state.sesion_device_graph}
                                                                    downloadName="Sessions By Device"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="">
                                                        {this.state.is_session_device_loaded == true ?
                                                            <Sunbrust_chart card_id="sessionsByDevice" card_class="icz-sectionchart" graph-data={this.state.sesion_device_graph} />
                                                            : <Loader />}
                                                    </div>

                                                </div>
                                            </div>


                                            <div className="grid col_span_2 icz-sectioncardwrapper">
                                                <div className="icz-sectioncard">
                                                    <div className="icz-cardheader flex-wrap justify-content-between">
                                                        <div className="icz-cardtitle">
                                                            Organic Landing Page Performance
                                                        </div>
                                                        <div className="icz-cardfilter">
                                                            <button className="icz-btn" onClick={this.searchShow}>Know More</button>
                                                            <div className="icz-cardbtnwrapper icz-chartexport">
                                                                <ChartExport
                                                                    ChartId='organicLandingPagePerformance'
                                                                    export_data={this.state.treegraph}
                                                                    downloadName="Organic Landing Page Performance"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="">
                                                        {this.state.is_organic_landing_loaded ?
                                                            <>
                                                                <RiTreegraph1 chart_id="organicLandingPagePerformance" chart_class="icz-sectionchart"
                                                                    graph-data={this.state.treegraph}
                                                                    parentCallback={this.treemapparentCallback}
                                                                    Level_Counter={this.state.Deep_Dive_level}
                                                                    parentCallback2={this.treemapparentCallback2}
                                                                    Deep_Dive_BreadCrumb={this.state.Deep_Dive_Name}
                                                                />
                                                            </>
                                                            : <Loader />}
                                                    </div>


                                                </div>
                                            </div>
                                        </div>

                                        {this.state.show &&
                                            <div className="icz-row">
                                                <Col className="icz-sectioncardwrapper" sm={12} lg={12}>
                                                    <div className="icz-sectioncard">
                                                        <Col sm={12} className="icz-cardheader flex-wrap justify-content-between">
                                                            <Col lg={8} className="icz-cardtitle">
                                                                Organic landing Page performance
                                                            </Col>
                                                            <Col lg={4} className="icz-cardfilter">
                                                                <button className="icz-btn" onClick={this.searchHide}>Close</button>
                                                            </Col>
                                                        </Col>
                                                        <div className="icz-table">
                                                            {this.state.is_landing_table_loaded == true ?
                                                                <DataTable isPageInfoEnable={true} Headers={this.state.table_header} TableSize={5} TableData={this.state.table_graph}
                                                                    className="MainDiv icz-table" />
                                                                : <Loader />}

                                                        </div>
                                                    </div>

                                                </Col>
                                            </div>
                                        }

                                        {this.state.trafficeChannel === 'Social' || this.state.trafficeChannel === 'Direct' || this.state.trafficeChannel === 'Referral' ? '' :
                                            <div className="grid grid_cols_4 icz-row">
                                                <div className="grid col_span_2 icz-sectioncardwrapper">
                                                    <div className="icz-sectioncard">
                                                        <div sm={12} className="icz-cardheader flex-wrap justify-content-between">
                                                            <div className="icz-cardtitle">
                                                                Keyword Rankings
                                                            </div>
                                                            <div className="icz-cardfilter">
                                                                <div className="icz-cardbtnwrapper icz-chartexport">
                                                                    <ChartExport
                                                                        ChartId='keywordRankings'
                                                                        export_data={this.state.keyword_graph}
                                                                        downloadName="Keyword Rankings"
                                                                    />
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className="">
                                                            {this.state.is_keyword_ranking_loaded == true ?
                                                                <LocationBarChart card_id="location-chart" card_class="icz-sectionchart" graph-data={this.state.keyword_graph} />
                                                                : <Loader />}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="grid col_span_2 icz-sectioncardwrapper" >
                                                    <div className="icz-sectioncard">
                                                        <div sm={12} className="icz-cardheader flex-wrap justify-content-between">
                                                            <div lg={6} className="icz-cardtitle">
                                                                Search By Search Type
                                                            </div>

                                                            <div lg={6} className="icz-cardfilter">
                                                                <DailydataDropdown dropdown_options=
                                                                    {this.state.dropdown_options}
                                                                    dropdown_placeholder="Impression" parentCallback={this.searchbysearchhandleCallback} />

                                                                <div className="icz-cardbtnwrapper icz-chartexport">
                                                                    <ChartExport
                                                                        ChartId='searchBySearchType'
                                                                        export_data={this.state.search_by_graph}
                                                                        downloadName="Search By Search Type"
                                                                    />
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className="">
                                                            {this.state.is_search_by_search_type_loaded == true ?
                                                                <ColumnLineChart_1 chart_id="searchBySearchType" chart_class="icz-sectionchart" graph-data={this.state.search_by_graph} metric_1={this.state.search_type} metric_2={"CTR"} />
                                                                : <Loader />}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}


                                        {this.state.trafficeChannel === 'Social' || this.state.trafficeChannel === 'Direct' || this.state.trafficeChannel === 'Referral' ? '' :
                                            <div className="icz-row">
                                                <Col className="icz-sectioncardwrapper" sm={12} lg={12}>
                                                    <div className="icz-sectioncard">
                                                        <Col sm={12} className="icz-cardheader flex-wrap justify-content-between">
                                                            <Col lg={4} className="icz-cardtitle">
                                                                Search Queries
                                                            </Col>

                                                            <Col lg={8} className="icz-cardfilter">
                                                                <button className="icz-btn" onClick={this.eventShow}>Know More</button>
                                                                <div className="icz-cardbtnwrapper icz-chartexport">
                                                                    <ChartExport
                                                                        ChartId='searchQueries'
                                                                        export_data={this.state.search_terms_bubble_graph}
                                                                        downloadName="Search Queries"
                                                                    />
                                                                </div>
                                                            </Col>

                                                        </Col>
                                                        <div className="">
                                                            {this.state.is_bubble_graph_data_loaded == true ?
                                                                <BubbleTextchart card_id="searchQueries" card_class="icz-sectionchart" metric_1={"Clicks"} metric_2={"Impression"} tooltip_label={'CTR'} graph-data={this.state.search_terms_bubble_graph} />
                                                                : < Loader />}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </div>}

                                        <span ref={this.scrollSearch} ></span>

                                        {this.state.isActive ?
                                            <div className="icz-row">
                                                <Col className="icz-sectioncardwrapper" sm={12} lg={12}>
                                                    <div className="icz-sectioncard">
                                                        <div className="icz-cardheader">
                                                            <Col className="icz-cardtitle">
                                                            </Col>
                                                            <Col className="icz-cardfilter">
                                                                <button className="icz-btn" onClick={this.eventHide}>Close</button>
                                                            </Col>
                                                        </div>
                                                        <div className="icz-table">
                                                            {this.state.is_search_table_loaded == true ?
                                                                <DataTable isPageInfoEnable={true} Headers={this.state.table_search} TableSize={5} TableData={this.state.table_date_graph}
                                                                    className="MainDiv icz-table" />

                                                                : <Loader />}
                                                        </div>
                                                    </div>

                                                </Col>
                                            </div>
                                            : null}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </Wrapper >

        )
    }
}

function ReduxStateToProps(state) {
    return {
        start_date: state.date.startDate,
        end_date: state.date.endDate,
        previous_start_date: state.date.prevStartDate,
        previous_end_date: state.date.prevEndDate,
    };
}

export default connect(ReduxStateToProps)(Earned)